export enum DOTRejectionReasonType {
  NonCompliance = 1,
  OpenRecall,
  Over120Days,
  MissingInfo,
  Other
}
